module.exports = __webpack_public_path__ + "static/media/header-subteam-sample.2987839d.png";